export default __webpack_public_path__ + "static/media/icon-download.f9746859.svg";